import CalendarItemWithServiceParticipation from './CalendarItemWithServiceParticipation';

export default {
    ...CalendarItemWithServiceParticipation,
    name: CalendarItemWithServiceParticipation.name + '_resource',
};
